import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React, { createContext, useContext, useEffect, useState } from 'react';
const CatalogContext = createContext(null);
export const useCatalog = () => useContext(CatalogContext);
export function CatalogProvider({
  children
}) {
  __useLocale();
  const [data, setData] = useState({
    countries: [],
    cities: [],
    hotels: [],
    visas: [],
    airports: [],
    buses: [],
    flights: [],
    content: {}
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const [hotelFilter, setHotelFilter] = useState({});
  const [visaFilter, setVisaFilter] = useState({});
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError('');
    fetch('/api/catalog.php', {
      signal: controller.signal,
      cache: 'no-store'
    }).then(async response => {
      if (!response.ok) throw new Error('catalog');
      const result = await response.json();
      if (!['countries', 'cities', 'hotels', 'visas'].every(key => Array.isArray(result[key]))) throw new Error('catalog');
      setData(result);
    }).catch(err => {
      if (err.name !== 'AbortError') setError(__tr("تعذر تحميل الدول والفنادق والتأشيرات. يرجى المحاولة مرة أخرى."));
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [attempt]);
  return <CatalogContext.Provider value={{
    ...data,
    loading,
    error,
    retry: () => setAttempt(n => n + 1),
    hotelFilter,
    setHotelFilter,
    visaFilter,
    setVisaFilter
  }}>{__tr(children)}</CatalogContext.Provider>;
}
export function CatalogStatus({
  empty = false
}) {
  __useLocale();
  const {
    loading,
    error,
    retry
  } = useCatalog();
  if (loading) return <p role="status" className="text-center py-6">{__tr("جارٍ تحميل البيانات…")}</p>;
  if (error) return <div role="alert" className="text-center py-6 text-red-700">{__tr(error)} <button onClick={retry} className="underline">{__tr("إعادة المحاولة")}</button></div>;
  return empty ? <p role="status" className="text-center py-6 text-gray-500">{__tr("لا توجد نتائج متاحة حاليًا.")}</p> : null;
}
export function countryName(value, countries) {
  return countries.find(c => c.value === value || c.name === value)?.name || value;
}
export function cityName(value, cities) {
  return cities.find(c => c.code === value || c.name === value)?.name || value;
}
